import { QueryEntity } from "@datorama/akita";
import { singleton } from "tsyringe";

import VotesStore, { VotesState } from "../stores/VotesStore";

@singleton()
class VotesQuery extends QueryEntity<VotesState> {
    constructor(protected store: VotesStore) {
        super(store);
    }

    selectByReviewId(reviewId: number) {
        return this.selectEntity(reviewId);
    }
}

export default VotesQuery;
